import { Injectable } from '@angular/core';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { Subject } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { Platform } from "@ionic/angular";
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class GeolocationService {
  public lat;
  public lng;
  public objUserLocation: {};
  public _Location = new Subject<any>();

  constructor(private geolocation: Geolocation,
    public locationAccuracy: LocationAccuracy,
    public androidPermissions: AndroidPermissions,
    public platform: Platform,
    private alertController: AlertController) { }

  getGeoLocation() {
    let options = {
      enableHighAccuracy: false,
      timeout: 10000,
      maximumAge: 30000,
    };

    let watch = this.geolocation.watchPosition(options);
    watch.pipe(throttleTime(30000)).subscribe((data: any) => {
      try {
        this.lat = data.coords.latitude;
        this.lng = data.coords.longitude;
        this.objUserLocation = {
          lat: this.lat,
          lng: this.lng
        };
        this._Location.next(this.objUserLocation);
        console.log("watch objLocation", this.objUserLocation);
      } catch (error) {
        console.log("error  watch", error);
        this.showAlertGps();
      }
    }, (err) => {
      console.log("error  watch", err);
      this.showAlertGps();
    });
  }


  //Check if application having GPS access permission  
  checkGPSPermission() {
    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION).then(
      result => {
        if (result.hasPermission) {

          //If having permission show 'Turn On GPS' dialogue
          this.askToTurnOnGPS();
        } else {

          //If not having permission ask for permission
          this.requestGPSPermission();
        }
      },
      err => {
        alert(err);
      }
    );
  }


  requestGPSPermission() {
    this.locationAccuracy.canRequest().then((canRequest: boolean) => {
      if (canRequest) {
        console.log("canRequest flagGps");
        this.getGeoLocation();
      } else {
        //Show 'GPS Permission Request' dialogue
        this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION)
          .then(
            () => {
              // call method to turn on GPS
              this.askToTurnOnGPS();
            },
            error => {
              //Show alert if user click on 'No Thanks'
              console.log('requestPermission Error requesting location permissions ' + error);
            }
          );
      }
    });
  }


  askToTurnOnGPS() {
    this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
      () => {
        // When GPS Turned ON call method to get Accurate location coordinates
        console.log("locationAccuracy");
        this.getGeoLocation();
      },
      error => {
        console.log('Error requesting location permissions ' + JSON.stringify(error));
      }
    );
  }


  async showAlertGps() {
    // await this.alertController.dismiss();
    // alert('abre alerta');
    const alertCtrl = await this.alertController.create({
      header: 'Geolocalización',
      message: 'Debes tener los permisos de Geolocalización y Habilitar la Posición GPS en tu celular.',
      backdropDismiss: false,
      buttons: [
        {
          text: 'Activar GPS',
          cssClass: 'secondary',
          handler: async (blah) => {
            // console.log('Confirm Cancel: blah');
            await this.checkGPSPermission();
          }
        }
      ]
    });

    await alertCtrl.present();
  }

}
